import { convertNumber } from 'components/forms/Number/Field'
import numberFormatter from '../../../../helpers/numberFormatter'
const bankersRound = (n, d = 2) => {
	let x = n * Math.pow(10, d)
	let r = Math.round(x)
	let br = Math.abs(x) % 1 === 0.5 ? (r % 2 === 0 ? r : r - 1) : r
	return br / Math.pow(10, d)
}
const roundingToNearest = (num) => (Math.ceil(num * 20 - 0.5) / 20).toFixed(2)

export const generateDifferentPrices = (selectedCol, product, priceKey = '', percentValue, selectVal) => {
 	const target = priceKey === 'newPrice' ? 'price' : 'priceInCafe'
 	product[priceKey] = product[target]?.map((el) => el === 0 ? null : el)
	selectedCol.forEach((position) => {
		if(product[priceKey][position]) {
			const calcPercentValue = product[priceKey][position] * (1 + percentValue / 100)
			const roundedValue = selectVal.toNearest ? roundingToNearest(calcPercentValue) : bankersRound(calcPercentValue, selectVal.value)
			product[priceKey][position] = roundedValue
		}
	})
 	return product
}

const customNumFormatter = (value) => +roundingToNearest(+value?.replace(/\,/g, '.').replace(/[^\d.-]/g, ''))

export const generateOnEditorPreparing = (e, locale) => {
	if(!e.dataField || !e.dataField.includes('new')) {
		return
	}
	const target = e.dataField === 'newPrice' ? 'price' : 'priceInCafe'
	const { idx } = e
	const capitalizeName = e.dataField === 'newPrice' ? 'newPrice' : 'newPriceInCafe'
	const value = e.value
	if(value) {
		const prices = [...e.row.data[target]]
		e.editorOptions.value = Array.isArray(value) ? numberFormatter(value[idx], { locale }) || '' : (() => {
			prices[idx] = customNumFormatter(value)
			e.row.data[capitalizeName] = prices
		})()
		e.editorOptions.onValueChanged = args => {
			if(Array.isArray(value)) {
				const newVal = [...value]
				newVal[idx] = convertNumber(args.value, locale)
				e.setValue(newVal)
			} else {
				e.setValue(convertNumber(args.value, locale))
			}
		}
	}
}
